import { useCallback } from "react";
import { getAllUnavailableItemIds } from "../../../utils/help/itemDetails/itemDetails";
import { useAppSelector } from "../useReduxHooks";

/** Whether the menu still serves an offer entity: the item is not out of stock. */
export const useOfferEntityAvailability = () => {
  const entityImageLookup = useAppSelector(
    (state) => state.config.entityImageLookup
  );
  const itemStatus = useAppSelector((state) => state.itemStatus);

  return useCallback(
    (entityId: string) => {
      const itemId = entityImageLookup[entityId]?.itemId;

      return (
        itemId === undefined ||
        !getAllUnavailableItemIds(itemStatus).allUnavailableItemIds.includes(
          itemId
        )
      );
    },
    [entityImageLookup, itemStatus]
  );
};
